module.exports = __webpack_public_path__ + "static/022-e8611261fe999439d11b1f206ef7a898.jpg";